export default __webpack_public_path__ + "static/media/moore-foundation-logo.fad7cf26.svg";